<div class="px-7 py-7">
  @if (isQuarterCloseEnabled() && isClosingPanelEnabled()) {
    <aux-workflow-panel
      className="mb-4"
      [workflowName]="workflowName"
      [processing]="iCloseMonthsProcessing()!"
      [hasUserPermissions]="userHasLockPrepaidPermission()"
    />
  }

  <div class="relative mb-4">
    <aux-route-tab-group [tabs]="tabs" [indexFn]="indexFn" variant="button" />
  </div>

  <router-outlet />
</div>
